module.exports = {
  menu: {
    1001: "管理",
    1002: "任务面板",
    1003: "项目",
    1004: "信息",
    1005: "账户",
    1006: "商业案例",
    1007: "状态",
    1008: "设置",
  },
  login: {
    1001: '登录',
    1002: '欢迎登录 XPROJECT',
    1003: '账号',
    1004: '请输入账号',
    1005: '密码',
    1006: '请输入登录密码',
    1007: '记住登录密码',
    1008: '忘记密码？',
    1009: '忘记密码',
    1010: '邮箱',
    1011: '请输入邮箱',
    1012: '找回',
    1013: '确认密码',
    1014: '请输入密码',
    1015: '立即修改',
    1016: '请输入邮箱！',
    1017: '请输入密码！',
    1018: '请输入账号！',
  },
  home: {
    1001: "Home",
    1002: "Hello",
    1003: " Welcome to 爱察客｜ICHUK® Project Management System",
    1004: "Log out",
    1005: "Chinese",
    1006: "English",
    1007: "2020 © iChuk.com iChuk 江苏爱察信息技术有限公司 版权所有",
    1008: "苏ICP备12049303号-1",
    1009: "消息提醒",
    1010: " is out of date",
    1011: "Back",
  },
  management: {
    1001: "My Workload",
    1002: "Project View",
    1003: "Task View",
    1004: "My Center",
    1005: "Project Center",
    1006: "Project Resource Map",
    1007: "Resource Center",
    1008: "Dashboard",
    1009: "My Work",
    1010: "My Tasks",
    1011: "Go to board",
    1012: "My Projects",
    1013: "Go to board",
    1014: "More",
  },
  mypanel: {
    1001: '我的面板',
    1002: '姓名',
    1003: '电话',
    1004: '我的工作量',
  },
  projectcenter: {
    1001: '工作集',
    1002: '过程',
    // 1003: '清除',
    1004: '搜索',
    1005: '里程碑',
    1006: '关系图',
    1007: '资源信息',
    1008: '活跃',
    1009: '封存',
    1010: '保密',
    1011: '创建项目',
    1012: '项目名称',
    1013: '输入项目名称',
    1014: '选择工作集',
    1015: '选择过程',
    1016: '说明',
    1017: '项目范围',
    1018: '生产线',
    1019: 'PPM项目编号',
    1020: 'PPM财务编号',
    1021: '招募成员',
    1022: '是',
    1023: '否',
  },
  taskpanel: {
    1001: '与我有关',
    1002: '创建任务面板',
  },
  resource: {
    1001: '分类',
    1002: '全部',
    1003: '权限',
  },
  button:{
    1001:'创建',
    1002:'视图',
    1003:'打印',
    1004:'下载',
    1005:'清除',
    1006:'取消',
    1007:'确认',
  }
}